import {
    ContainerCode,
    ContainerGeneration,
    ContainerVolume,
    DefaultTemperatureRange,
    TemperatureRange,
    TemperatureRangeAll,
} from 'app/enums/label.enums'
import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    ContainerType,
} from '../../Containers/containers.types'

type ContainerTypeUpdateFields = keyof ContainerType

const getFields = (
    getAllowedValues: (obj: Record<string, string>) => Record<string, string>,
): DTOCardFormField<ContainerTypeUpdateFields>[] => {
    return [
        {
            id: 'summary',
            title: 'Summary',
            className: 'summary',
            hasColumns: true,
            fields: [
                {
                    id: 'column1',
                    fields: [
                        {
                            name: 'containerModel',
                            componentName: 'InputSingleline',
                            disabled: true,
                            labelKey: 'CONTAINER_MODEL',
                        },
                        {
                            name: 'containerVolume',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(ContainerVolume),
                            required: true,
                            labelKey: 'CONTAINER_VOLUME_LITER',
                        },
                        {
                            name: 'tareWeight',
                            componentName: 'IntegerInput',
                            required: true,
                            labelKey: 'CONTAINER_TARE_WEIGHT_KG',
                        },
                        {
                            name: 'maxGrossWeight',
                            componentName: 'IntegerInput',
                            required: true,
                            labelKey: 'CONTAINER_MAX_GROSS_WEIGHT_KG',
                        },
                    ],
                },
                {
                    id: 'column2',
                    fields: [
                        {
                            name: 'containerCode',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(ContainerCode),
                            disabled: true,
                            labelKey: 'CONTAINER_CODE',
                        },
                        {
                            name: 'temperatureRange',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(TemperatureRange),
                            disabled: true,
                            labelKey: 'TEMPERATURE_RANGE',
                        },
                        {
                            name: 'containerGeneration',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(ContainerGeneration),
                            required: true,
                            labelKey: 'CONTAINER_GENERATION',
                        },
                        {
                            name: 'isPrototype',
                            componentName: 'Checkbox',
                            labelKey: 'IS_PROTOTYPE',
                        },

                    ],
                },
                {
                    id: 'column3',
                    fields: [
                        {
                            name: 'applicableTempRange',
                            componentName: 'MultiEnumSelector',
                            allowedValues: getAllowedValues(TemperatureRangeAll),
                            disabled: true,
                            labelKey: 'TEMPERATURE_RANGES',
                        },
                        {
                            name: 'defaultTempRange',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(DefaultTemperatureRange),
                            disabled: true,
                            labelKey: 'DEFAULT_TEMPERATURE_RANGE',
                        },
                        {
                            name: 'toleranceRange',
                            componentName: 'IntegerInput',
                            labelKey: 'WEIGHT_TOLERANCE_PERCENT',
                        },
                    ],
                },
                {
                    id: 'column4',
                    fields: [{
                        name: 'containerPicture',
                        componentName: 'AttachmentsObjectSelector',
                        labelKey: 'CONTAINER_PICTURE',
                    }],
                },
            ],
        },
        {
            id: 'extDimensions',
            title: 'External Dimensions',
            className: 'extDimensions',
            fields: [
                {
                    name: 'extDimLength',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'EXTERNAL_DIMENSIONS_LENGTH_MM',
                },
                {
                    name: 'extDimWidth',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'EXTERNAL_DIMENSIONS_WIDTH_MM',
                },
                {
                    name: 'extDimHeight',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'EXTERNAL_DIMENSIONS_HEIGHT_MM',
                },
            ],
        },
        {
            id: 'intDimensions',
            title: 'Internal Dimensions',
            className: 'intDimensions',
            fields: [
                {
                    name: 'intDimLength',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'INTERNAL_DIMENSIONS_LENGTH_MM',
                },
                {
                    name: 'intDimWidth',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'INTERNAL_DIMENSIONS_WIDTH_MM',
                },
                {
                    name: 'intDimHeight',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'INTERNAL_DIMENSIONS_HEIGHT_MM',
                },
            ],
        },
        {
            id: 'temperatureRange',
            title: 'Temperature Range',
            className: 'temperatureRange',
            fields: [
                {
                    name: 'intTempRangeStart',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'INTERNAL_TEMPERATURE_RANGE_START_C',
                },
                {
                    name: 'intTempRangeEnd',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'INTERNAL_TEMPERATURE_RANGE_END_C',
                },
                {
                    name: 'extTempRangeStart',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'EXTERNAL_TEMPERATURE_RANGE_START_C',
                },
                {
                    name: 'extTempRangeEnd',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'EXTERNAL_TEMPERATURE_RANGE_END_C',
                },
            ],
        },
        {
            id: 'storageRange',
            title: 'Storage Range',
            className: 'storageRange',
            fields: [
                {
                    name: 'extStorageRangeStart',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'EXTERNAL_STORAGE_RANGE_START_C',
                },
                {
                    name: 'extStorageRangeEnd',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'EXTERNAL_STORAGE_RANGE_END_C',
                },
            ],
        },
    ]
}

export default getFields
